import vipTypeEnum from '@data/vipTypeEnum';
import moment from 'moment';

/**
 * @module  shixunApp/userUtil
 */

export default {

    /**
     * @param   {Object}  data    user data
     * @return  {Object}
     */
    createUser : function (data = {}) {

        let user = {

            vipDueTime : null,
            vipInfoMap : null,

            /**
             * @method getDay
             * @param {Number}  dateTime    timestamp (millsecond)
             * @returns {number}
             */
            getDay : function (dateTime){
                if (!dateTime || dateTime == '0000-00-00 00:00')
                {
                    return 0;
                }
                const NowTime = new Date();
                const EndTime = new Date(dateTime.replace(' ', 'T'));
                const t = EndTime.getTime() - NowTime.getTime();
                const d = Math.floor(t / 1000 / 60 / 60 / 24)
                return d
            },

            /**
             * @method  getVipInfo
             * @return  Object  {course_vod, datum, super, rencai, underline_course_sponsor, atlas_vip}
             */
            getVipInfo : function () {
                if (this.vipInfoMap != null)
                {
                    return this.vipInfoMap;
                }

                if (this.vipDueTime != null)
                {
                    const nullTime    = '0000-00-00 00:00';
                    const nowTime     = moment().format('YYYY-MM-DD HH:mm');

                    this.vipInfoMap = {
                        course_vod : {
                            name : '课程VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.COURSE_VOD] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.COURSE_VOD] || nullTime) >= nowTime,
                            neverOpen : !this.vipDueTime[vipTypeEnum.COURSE_VOD] || this.vipDueTime[vipTypeEnum.COURSE_VOD] === nullTime,
                            expiring : this.getDay(this.vipDueTime[vipTypeEnum.COURSE_VOD])
                        },
                        datum : {
                            name : '资料VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.DATUM] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.DATUM] || nullTime) >= nowTime,
                            neverOpen : !this.vipDueTime[vipTypeEnum.DATUM] || this.vipDueTime[vipTypeEnum.DATUM] === nullTime,
                            expiring : this.getDay(this.vipDueTime[vipTypeEnum.DATUM])
                        },
                        super : {
                            name : '超级SVIP',
                            dueTime : this.vipDueTime[vipTypeEnum.SUPER] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.SUPER] || nullTime) >= nowTime,
                            neverOpen : !this.vipDueTime[vipTypeEnum.SUPER] || this.vipDueTime[vipTypeEnum.SUPER] === nullTime,
                            expiring : this.getDay(this.vipDueTime[vipTypeEnum.SUPER])
                        },
                        rencai : {
                            name : '人才园方VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.RENCAI] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.RENCAI] || nullTime) >= nowTime,
                            neverOpen : !this.vipDueTime[vipTypeEnum.RENCAI] || this.vipDueTime[vipTypeEnum.RENCAI] === nullTime,
                            expiring : this.getDay(this.vipDueTime[vipTypeEnum.RENCAI])
                        },
                        underline_course_sponsor : {
                            name : '线下课主办方VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.UNDERLINE_COURSE_SPONSOR] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.UNDERLINE_COURSE_SPONSOR] || nullTime) >= nowTime,
                            neverOpen : !this.vipDueTime[vipTypeEnum.UNDERLINE_COURSE_SPONSOR] || this.vipDueTime[vipTypeEnum.UNDERLINE_COURSE_SPONSOR] === nullTime,
                            expiring : this.getDay(this.vipDueTime[vipTypeEnum.UNDERLINE_COURSE_SPONSOR])
                        },
                        atlas_vip : {
                            name : '精美环创VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.ATLAS] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.ATLAS] || nullTime) >= nowTime,
                            neverOpen : !this.vipDueTime[vipTypeEnum.ATLAS] || this.vipDueTime[vipTypeEnum.ATLAS] === nullTime,
                            expiring : this.getDay(this.vipDueTime[vipTypeEnum.ATLAS])
                        },
                        kindergarten_vip : {
                            name : '园长商学院VIP',
                            dueTime : this.vipDueTime[vipTypeEnum.KINDERGARTEN] || nullTime,
                            status : (this.vipDueTime[vipTypeEnum.KINDERGARTEN] || nullTime) >= nowTime,
                            neverOpen : !this.vipDueTime[vipTypeEnum.KINDERGARTEN] || this.vipDueTime[vipTypeEnum.KINDERGARTEN] === nullTime,
                            expiring : this.getDay(this.vipDueTime[vipTypeEnum.KINDERGARTEN])
                        }
                    }
                }

                return this.vipInfoMap;
            },

            /**
             * get max vip due time from all vip type
             * @method  getVipDueTime
             * @return  {String}
             */
            getVipDueTime : function() {
                const vipList = this.getVipInfo();
                let timeout = '';
                // compute max value
                for (let key in vipList)
                {
                    if (vipList[key].status && vipList[key].dueTime > timeout)
                    {
                        timeout = vipList[key].dueTime;
                    }
                }
                return timeout;
            },

            /**
             * @method  isVip
             * @return {boolean}
             */
            isVipUser : function () {

                const vipList = this.getVipInfo();
                for (let key in vipList)
                {
                    if (vipList[key].status)
                    {
                        return true;
                    }
                }
                return false;
            },

            /**
             * @method  isVipType
             * @param   {String}  type  course_vod | datum | super | rencai | underline_course_sponsor | atlas_vip
             * @return  {Boolean}
             */
            isVipType : function (type) {

                const vipInfoMap = this.getVipInfo();

                if (vipInfoMap === null)
                {
                    return false;
                }

                if (typeof (vipInfoMap[type]) != 'object')
                {
                    return false;
                }

                return vipInfoMap[type].status;
            },

            isHasExpired() {

                const vipInfoMap = this.getVipInfo();

                if (vipInfoMap === null)
                {
                    return false;
                }

                for (let key in vipInfoMap)
                {
                    if (!vipInfoMap[key].neverOpen)
                    {
                        return true;
                    }
                }

                return false;
            },

            /**
             * @method  isContentHasVipPrivilege
             * @param   {String}    contentType     'course_vod'|'datum'|'atlas'
             * @return  {Boolean}
             */
            isContentHasVipPrivilege : function (contentType) {

                const vipInfoMap = this.getVipInfo();

                if (vipInfoMap === null)
                {
                    return false;
                }

                // SVIP has all privilege
                if (vipInfoMap.super.dueTime >= moment().format('YYYY-MM-DD HH:mm'))
                {
                    // SVIP 仅对 点播课、资料和图集下载有特权
                    if (contentType === 'course_vod' || contentType === 'datum' || contentType === 'atlas')
                    {
                        return true;
                    }
                }

                // check normal VIP
                switch (contentType) {
                    case 'course_vod' :
                        if (vipInfoMap.course_vod.dueTime >= moment().format('YYYY-MM-DD HH:mm'))
                        {
                            return true;
                        }
                        break;
                    case 'datum' :
                        if (vipInfoMap.datum.dueTime >= moment().format('YYYY-MM-DD HH:mm'))
                        {
                            return true;
                        }
                        break;
                    case 'atlas' :
                        if (vipInfoMap.atlas_vip.dueTime >= moment().format('YYYY-MM-DD HH:mm'))
                        {
                            return true;
                        }
                        break;
                }

                return false;

            }

        };

        // init data
        for (let key in data)
        {
            user[key] = data[key];
        }

        return user;
    }

};

